// src/AdminLogin.jsx
import { useState } from "react";
import { useNavigate } from 'react-router-dom';


export default function AdminLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");

        const res = await fetch("/api/login", {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email, password }),
        });

        if (res.ok) {
            const data = await res.json();
            if (data.role === "admin") {
                // ✅ Delay longer to ensure cookie propagates
                setTimeout(() => {
                    window.location.href = "/admin";
                }, 300);

            } else {
                setError("Access denied. Admins only.");
            }
        } else {
            setError("Invalid email or password.");
        }
    };


    return (
        <div className="flex flex-col items-center justify-center h-screen px-4">
            <h1 className="text-2xl font-bold mb-6">Admin Login</h1>
            <form onSubmit={handleLogin} className="w-full max-w-sm space-y-4">
                <input
                    className="w-full p-2 border rounded"
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <input
                    className="w-full p-2 border rounded"
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <button
                    type="submit"
                    className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
                >
                    Sign In
                </button>
                {error && <p className="text-red-600 text-sm">{error}</p>}

                <button
                    type="button"
                    onClick={() => navigate("/login")}
                    className="mt-4 text-sm text-gray-500 underline"
                >
                    ← Back to Main Login
                </button>

            </form>
        </div>
    );
}
